import { LESS_768_MEDIA_QUERY } from './../../../../consts/adaptive';
import { MORE_768_MEDIA_QUERY } from '../../../../consts/adaptive';

export const styles = {
    container: {
        padding: [16, 0, 5, 0],
        fontSize: 16,
        [LESS_768_MEDIA_QUERY]: {
            paddingLeft: 10,
        },
    },
    emptyText: {},
    list: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
    },
    header: {
        fontSize: 24,
        lineHeight: '32px',
        color: '#313140',
        fontWeight: 700,
    },
    icon: {
        display: 'inline-flex',
    },
    facilityGroup: {
        marginBottom: 24,
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
    },
    title_name: {
        'margin-left': '5px',
    },
    title: {
        display: 'inline-flex',
        margin: 0,
        marginBottom: 5,
        alignItems: 'center',
    },
    text: {
        margin: 0,
        lineHeight: '24px',
    },

    [MORE_768_MEDIA_QUERY]: {
        container: {
            padding: [0, 0, 5, 0],
            fontSize: 14,
        },
        list: {
            columnCount: 4,
        },
    },
};

export type ComponentJSSClasses = typeof styles;
